import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useAssignedTeachers({ courseId, enabled = false }) {
  const { privateFetch } = useContext(FetchContext);

  const getTeachers = async () => {
    if (!courseId) {
      return [];
    }

    try {
      const res = await privateFetch.get(`/v1/admin/course-teachers/${courseId}`);

      // Try multiple response structures
      let teachers = [];

      if (res?.data?.data?.result) {
        teachers = res.data.data.result;
      } else if (Array.isArray(res?.data?.data)) {
        teachers = res.data.data;
      } else if (res?.data?.result) {
        teachers = res.data.result;
      } else if (Array.isArray(res?.data)) {
        teachers = res.data;
      }

      return Array.isArray(teachers) ? teachers : [];
    } catch (error) {
      return [];
    }
  };

  return useQuery(['assigned-teachers', courseId], getTeachers, {
    enabled: enabled && !!courseId,
    keepPreviousData: true,
    staleTime: 30000, // Cache for 30 seconds
    retry: 1, // Only retry once on failure
    onError: (error) => {},
    onSuccess: (data) => {},
  });
}

export default useAssignedTeachers;
